<template>
  <div>
    <img :style="getStyle()" alt="banner" :src="getBanner()" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const imageMap = {
  vehicle: require('@/assets/images/vehicle-banner.jpg'),
  part: require('@/assets/images/part-banner.jpg'),
  product: require('@/assets/images/product/banner.jpg'),
  'product-inquiry': require('@/assets/images/product-inquiry/banner.jpg'),
  shoppingcart: require('@/assets/images/shoppingcart/banner.jpg'),
  order: require('@/assets/images/order/banner.jpg')
};

export default defineComponent({
  name: 'Banner',
  props: {
    type: {
      type: String,
      required: true,
      default: ''
    },
    style: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  methods: {
    getBanner() {
      return imageMap[this.type];
    },
    getStyle() {
      return this.style;
    }
  }
});
</script>

<style lang="scss" scoped>
img {
  display: block;
  height: 200px;
  width: 100%;
}
</style>
